import axios from "axios"

//添加一个请求拦截器，回调函数会在发出请求时执行  
//config:请求配置
axios.interceptors.request.use(config=>{
 // Do something before request is sent
 config.headers.productId=20;
 return config;
},error=>{
     // Do something with request error
     return Promise.reject(error);
})

//响应拦截器
axios.interceptors.response.use(response=>{
     // Do something before response is sent
     return response.data
},error=>{
    // Do something with response error
    return Promise.reject(error);
});

//封装一个get请求方法
function get(url,params={}){
    return new Promise((resolve,reject)=>{
        axios({
            method:'get',
            url,
            params
        }).then((data)=>{
            resolve(data)
        }).catch(err=>{
            reject(err)
        })
    })
}

//封装一个post请求方法
function post(url,data={}){
    return new Promise((resolve,reject)=>{
        axios({
            method:'post',
            url,
            data,
        }).then((data)=>{
            resolve(data)
        }).catch((err)=>{
            reject(err)
        })
    }) 
}
//封装post，parmars 接受参数的方法
function postparmars(url,params={}){
    return new Promise((resolve,reject)=>{
        axios({
            method:'post',
            url,
            params,
        }).then((data)=>{
            resolve(data)
        }).catch((err)=>{
            reject(err)
        })
    }) 
}
export {get,post,postparmars}


// WEBPACK FOOTER //
// ./src/utils/http.js